module.exports = __webpack_public_path__ + "assets/img/btn-detail-b82b1b30.png";